import English from './en-us.json'
import German from './de.json'

export const messages = {
    'en-US': English,
    en: English,
    de: German,
}
